var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuppliers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "inventory"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_3091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_3091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "inventory_2",
    d: "M12.9167 16.6043L9.375 13.0627L10.5417 11.896L12.9167 14.271L17.625 9.56266L18.7917 10.7293L12.9167 16.6043ZM17.5 8.3335H15.8333V4.16683H14.1667V6.66683H5.83333V4.16683H4.16667V15.8335H9.16667V17.5002H4.16667C3.70833 17.5002 3.31597 17.337 2.98958 17.0106C2.66319 16.6842 2.5 16.2918 2.5 15.8335V4.16683C2.5 3.7085 2.66319 3.31613 2.98958 2.98975C3.31597 2.66336 3.70833 2.50016 4.16667 2.50016H7.64583C7.79861 2.01405 8.09722 1.61475 8.54167 1.30225C8.98611 0.989746 9.47222 0.833496 10 0.833496C10.5556 0.833496 11.0521 0.989746 11.4896 1.30225C11.9271 1.61475 12.2222 2.01405 12.375 2.50016H15.8333C16.2917 2.50016 16.684 2.66336 17.0104 2.98975C17.3368 3.31613 17.5 3.7085 17.5 4.16683V8.3335ZM10 4.16683C10.2361 4.16683 10.434 4.08697 10.5938 3.92725C10.7535 3.76752 10.8333 3.56961 10.8333 3.3335C10.8333 3.09738 10.7535 2.89947 10.5938 2.73975C10.434 2.58002 10.2361 2.50016 10 2.50016C9.76389 2.50016 9.56597 2.58002 9.40625 2.73975C9.24653 2.89947 9.16667 3.09738 9.16667 3.3335C9.16667 3.56961 9.24653 3.76752 9.40625 3.92725C9.56597 4.08697 9.76389 4.16683 10 4.16683Z",
    fill: "url(#paint0_linear_106_3091)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_3091",
    x1: 10.6458,
    y1: 0.833496,
    x2: 10.6458,
    y2: 17.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/suppliers.74d8d1c03fc1ed0059121bff29869700.svg";
export { ForwardRef as ReactComponent };